module.exports = __webpack_public_path__ + "static/media/2_pl.ad0b13c0.png";